export default "__VITE_ASSET__ChxVNHWz__"